import { ChangeEvent } from 'react'

export const formatNumberWithCommas = (x: number) => {
  return formatter.format(x)
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
})

export const formatNumberWithoutSymbol = (x: number) => {
  return formatterWithoutSymbol.format(x)
}

const formatterWithoutSymbol = new Intl.NumberFormat('en-US', {
  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
})

export function formatPhoneNumber(phoneNumberString: number | string) {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3]
  }
  return null
}

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const inputNumber = (event: ChangeEvent, limit: number = 20): string => {
  const input = event.target as HTMLInputElement
  let v = input.value
  if (v) {
    const onlyNumber = /\D+/g
    if (onlyNumber.test(v)) {
      return v.replace(onlyNumber, '')
    } else {
      return v.substring(0, limit)
    }
  } else {
    return ''
  }
}

export const inputDecimalNumber = (
  event: ChangeEvent<HTMLInputElement>,
  integerLimit: number = 14,
  decimalLimit: number = 2,
): string => {
  const v = event.target.value.trim().replace(/[^0-9.]/g, '')

  if (v) {
    const regEx = new RegExp('^[.0-9]*$', 'g')
    if (v === '.') {
      return ''
    }
    if (regEx.test(v)) {
      let newValue = v.replace(
        /\./g,
        (
          (c) => (_: any) =>
            c++ ? '' : '.'
        )(0),
      )

      const maxWholeNumberLength = integerLimit
      if (!new RegExp('^d+(?:.d{1,2})?$', 'g').test(newValue)) {
        const [wholeNumber, decimalNumber] = newValue.split('.')
        if (wholeNumber.length > maxWholeNumberLength) {
          newValue = newValue.slice(0, maxWholeNumberLength)
        }
        if (decimalNumber && decimalNumber.length > decimalLimit) {
          newValue = newValue.slice(0, newValue.lastIndexOf('.') + 3)
        }
        return newValue
      }
      return newValue
    } else {
      return v.replace(/[^0-9.]/g, '')
    }
  } else {
    return ''
  }
}

export const onlyAlphaAndNumeric = (event: ChangeEvent, limit: number = 500): string => {
  const input = event.target as HTMLInputElement
  let v = input.value

  if (v) {
    const alphaAndNumericRegex = /[^a-zA-Z0-9]/g
    if (alphaAndNumericRegex.test(v)) {
      return v.replace(alphaAndNumericRegex, '')
    } else {
      return v.substring(0, limit)
    }
  } else {
    return ''
  }
}
